import { useQuery } from "@tanstack/react-query";
import { useAuth, authorizedAxios } from "@moonscape/shared";
import type { TaxYearTier } from "./useTaxYearCheckout";

export interface TaxYearTierRecommendation {
  txn_count: number;
  recommended_tier: TaxYearTier;
  min_allowed_tier: TaxYearTier;
  near_ceiling: boolean;
}

/**
 * Fetches the smallest tier that fits the user's per-year txn volume, plus a
 * near_ceiling hint for upselling when they're close to the cap. Drives both
 * pre-selection and warning banners in the tax-year checkout picker.
 */
export const useTaxYearTierRecommendation = (
  taxYear: number | null | undefined,
) => {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: ["tax-year-tier-recommendation", taxYear],
    enabled: Number.isFinite(taxYear),
    staleTime: 60_000,
    queryFn: async (): Promise<TaxYearTierRecommendation> => {
      const token = await getToken();
      const response = await authorizedAxios(token).get(
        `/stripe/tax-year-tier-recommendation?tax_year=${taxYear}`,
      );
      return response.data;
    },
  });
};
